<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-transparent md-absolute"
    :class="extraNavClasses"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <a href="#/">
          <h3 class="md-title"><strong>Control-IT</strong></h3>
        </a>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section-start="false">
              <!-- Here you can add your items from the section-start of your toolbar -->
            </mobile-menu>
            <md-list>
              <li class="md-list-item">
                <a
                  href="javascript:void(0)"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <drop-down
                      direction="down"
                      id="navigationDropdown"
                      :class="extraNavClasses"
                    >
                      <template v-slot:title>
                        <md-button
                          class="md-button md-button-link md-white md-simple dropdown-toggle"
                          data-toggle="dropdown"
                        >
                          <i class="material-icons">view_carousel</i>
                          <p>Navigation</p>
                        </md-button>
                      </template>

                      <ul class="dropdown-menu dropdown-with-icons">
                        <li>
                          <a href="#/">
                            <i class="material-icons">view_day</i>
                            <p>Home</p>
                          </a>
                        </li>

                        <li>
                          <a href="#/weekgoal">
                            <i class="material-icons">event</i>
                            <i
                              v-if="!$auth.isAuthenticated"
                              class="material-icons"
                              >lock</i
                            >
                            <p>Wochenziel</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/newStatus">
                            <i class="material-icons">battery_saver</i>
                            <i
                              v-if="!$auth.isAuthenticated"
                              class="material-icons"
                              >lock</i
                            >
                            <p>Status</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/chat">
                            <i class="material-icons">chat</i>
                            <i
                              v-if="!$auth.isAuthenticated"
                              class="material-icons"
                              >lock</i
                            >
                            <p>Chat</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/report">
                            <i class="material-icons">analytics</i>
                            <i
                              v-if="!$auth.isAuthenticated"
                              class="material-icons"
                              >lock</i
                            >
                            <p>Auswertung</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/profile">
                            <i class="material-icons">account_circle</i>
                            <i
                              v-if="!$auth.isAuthenticated"
                              class="material-icons"
                              >lock</i
                            >
                            <p>Profil</p>
                          </a>
                        </li>
                        <li>
                          <a href="#/theory">
                            <i class="material-icons">science</i>
                            <p>Was steckt dahinter?</p>
                          </a>
                        </li>
                        <li
                          v-if="
                            $auth.isAuthenticated &&
                            $auth.user[
                              'https://control-it-reflexion.de/roles'
                            ].includes('Administrator')
                          "
                        >
                          <a href="#/adminchat">
                            <i class="material-icons">admin_panel_settings</i>
                            <p>Admin Chat</p>
                          </a>
                        </li>
                      </ul>
                    </drop-down>
                  </div>
                </a>
              </li>
              <md-list-item v-if="!$auth.isAuthenticated" @click="login">
                <router-link to="#/">Login / Registrierung</router-link>
              </md-list-item>
              <md-list-item v-if="$auth.isAuthenticated" @click="logout">
                <router-link to="#/">Logout</router-link>
              </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 66);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu,
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
        ].includes(value);
      },
    },
    colorOnScroll: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
    };
  },
  computed: {},
  methods: {
    // Log the user in
    login() {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout() {
      this.$auth.logout({
        returnTo: window.location.origin,
      });
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();

      // open dropdown on mobile
      let navigationDropdown = document.getElementById("navigationDropdown");
      navigationDropdown.classList.add("open");
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }
    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    },
    scrollToElement() {
      let element_id = document.getElementById("downloadSection");
      if (element_id) {
        element_id.scrollIntoView({ block: "end", behavior: "smooth" });
      }
    },
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
};
</script>
